(function () {
	'use strict';

	function initReels() {
		var sections = document.querySelectorAll('.reels');
		if (!sections || sections.length === 0) return;

		sections.forEach(function (section) {
			var container = section.querySelector('.reels__slider');
			if (!container || typeof Swiper === 'undefined') return;

			var swiper = new Swiper(container, {
				slidesPerView: 'auto',
				spaceBetween: 12,
				watchSlidesProgress: true,
				a11y: true,
				loop: true,
				navigation: {
					nextEl: section.querySelector('.reels__button--next'),
					prevEl: section.querySelector('.reels__button--prev')
				},
				scrollbar: {
					el: container.querySelector('.swiper-scrollbar'),
					draggable: true,
					hide: false
				},
				breakpoints: {
					750: {
						spaceBetween: 24
					}
				},
				autoplay: {
					delay: 4000,
					disableOnInteraction: true,
					pauseOnMouseEnter: true
				},
				on: {
					slideChange: function (s) {
						handleSlideChange(section, s);
					}
				}
			});

			bindPlayButtons(section);
			bindVideoInteractions(section);
			handleSlideChange(section, swiper);

			// Setup responsive relocation for nav controls
			setupNavRelocationForSection(section);
		});

		// Bind one global resize/matchMedia listener for all reels sections
		bindGlobalResizeForReels();
	}

	function pauseAllVideos() {
		var allMediaWrappers = document.querySelectorAll('.reels__media.is-playing');
		allMediaWrappers.forEach(function (wrapper) {
			wrapper.classList.remove('is-playing');
			var video = wrapper.querySelector('video');
			if (video) {
				try {
					video.pause();
				} catch (e) {
				}
			}
			var holder = wrapper.querySelector('.reels__iframe-holder');
			if (holder && holder.firstChild) {
				holder.innerHTML = '';
			}
		});
	}

	function bindPlayButtons(section) {
		var slides = section.querySelectorAll('.reels__slide');
		slides.forEach(function (slide) {
			var playBtn = slide.querySelector('.reels__play');
			var mediaWrapper = slide.querySelector('.reels__media');
			if (!playBtn || !mediaWrapper) return;

			playBtn.addEventListener('click', function () {
				pauseAllVideos();
				var type = mediaWrapper.getAttribute('data-video-type');
				if (type === 'external') {
					var holder = slide.querySelector('.reels__iframe-holder');
					if (holder && !holder.querySelector('iframe')) {
						var provider = holder.getAttribute('data-provider');
						var id = holder.getAttribute('data-video-id');
						var src = '';
						if (provider === 'youtube') {
							src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&playsinline=1&mute=0&rel=0&modestbranding=1&controls=0';
						} else if (provider === 'vimeo') {
							src = 'https://player.vimeo.com/video/' + id + '?autoplay=1&playsinline=1&muted=0&controls=0&title=0&byline=0&portrait=0';
						}
						var iframe = document.createElement('iframe');
						iframe.src = src;
						iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
						iframe.setAttribute('allowfullscreen', 'true');
						var iframeTitle = (holder && holder.getAttribute('aria-label')) || (section.querySelector('.reels__title') && section.querySelector('.reels__title').textContent.trim()) || 'Video';
						iframe.setAttribute('title', iframeTitle);
						iframe.setAttribute('frameborder', '0');
						iframe.style.width = '100%';
						iframe.style.height = '100%';
						holder.appendChild(iframe);
					}
					mediaWrapper.classList.add('is-playing');
				} else if (type === 'shopify' || type === 'mp4') {
					var video = slide.querySelector('video');
					if (video) {
						try {
							video.play();
						} catch (e) {
						}
					}
					mediaWrapper.classList.add('is-playing');
				}
			});
		});
	}

	function bindVideoInteractions(section) {
		var videos = section.querySelectorAll('.reels__slide video.reels__video');
		videos.forEach(function (video) {
			if (video.dataset.reelsBound === 'true') return;
			var mediaWrapper = video.closest('.reels__media');
			if (!mediaWrapper) return;

			function showPlay() {
				mediaWrapper.classList.remove('is-playing');
			}

			video.addEventListener('click', function () {
				if (!video.paused) {
					try {
						video.pause();
					} catch (e) {
					}
					showPlay();
				}
			});
			video.addEventListener('pause', showPlay);
			video.addEventListener('ended', showPlay);
			video.dataset.reelsBound = 'true';
		});
	}

	function handleSlideChange(section, swiper) {
		var slides = section.querySelectorAll('.reels__slide');
		slides.forEach(function (slide, index) {
			var isActive = index === swiper.activeIndex;
			if (!isActive) {
				var mediaWrapper = slide.querySelector('.reels__media');
				if (mediaWrapper) mediaWrapper.classList.remove('is-playing');

				var vid = slide.querySelector('video');
				if (vid && !vid.paused) {
					try {
						vid.pause();
					} catch (e) {
					}
				}
				var holder = slide.querySelector('.reels__iframe-holder');
				if (holder && holder.firstChild) {
					holder.innerHTML = '';
				}
			}
		});
	}

	// ------------------------------
	// Responsive nav relocation logic
	// ------------------------------
	function ensureNavPlaceholder(section) {
		var header = section.querySelector('.reels__header');
		var nav = section.querySelector('.reels__nav');
		if (!header || !nav) return;
		var placeholder = section.querySelector('.reels__nav-placeholder');
		if (!placeholder) {
			placeholder = document.createElement('span');
			placeholder.className = 'reels__nav-placeholder';
			placeholder.setAttribute('aria-hidden', 'true');
			// Insert placeholder before the nav to mark original position
			nav.parentNode.insertBefore(placeholder, nav);
		}
	}

	function relocateNavForSection(section) {
		var nav = section.querySelector('.reels__nav');
		if (!nav) return;
		var cta = section.querySelector('.reels__cta');
		var placeholder = section.querySelector('.reels__nav-placeholder');
		var toMobile = window.innerWidth <= 749;

		if (toMobile && cta && nav.parentNode !== cta) {
			cta.appendChild(nav);
		} else if (!toMobile && placeholder && placeholder.parentNode && nav.previousSibling !== placeholder) {
			// Move back to original position before the placeholder
			placeholder.parentNode.insertBefore(nav, placeholder);
		}
	}

	function setupNavRelocationForSection(section) {
		ensureNavPlaceholder(section);
		relocateNavForSection(section);
	}

	var reelsNavResizeBound = false;

	function bindGlobalResizeForReels() {
		if (reelsNavResizeBound) return;
		reelsNavResizeBound = true;
		var mq = window.matchMedia('(max-width: 749px)');
		var debounceTimer = null;
		var updateAll = function () {
			var secs = document.querySelectorAll('.reels');
			secs.forEach(function (sec) {
				relocateNavForSection(sec);
			});
		};
		var debouncedUpdate = function () {
			clearTimeout(debounceTimer);
			debounceTimer = setTimeout(updateAll, 150);
		};
		// Listen to matchMedia changes (modern and legacy)
		if (mq.addEventListener) {
			mq.addEventListener('change', debouncedUpdate);
		} else if (mq.addListener) {
			mq.addListener(debouncedUpdate);
		}
		window.addEventListener('resize', debouncedUpdate);
		window.addEventListener('orientationchange', debouncedUpdate);
		// Run once
		updateAll();
	}

	document.addEventListener('DOMContentLoaded', initReels);
})();
